export enum SortDirection {
  Ascending = 1,
  Descending = 2
}

/** data sent to the API to load grid rows on demand */
export interface LazyLoadQueryParams {
  toSkip: number;
  rowsCount: number;
  sortField: string | null;
  sortDirection: SortDirection | null;
  includeCount?: boolean;
  filter: LazyLoadFilterParams | null;
}

export interface LazyLoadFilterParams {
  conditions: FieldCondition[];
}

export interface FieldCondition {
  fieldName: string;
  operator: string;
  value: string;
}
